"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useMarkerComponentMemo: ()=>useMarkerComponentMemo,
    markerComponentIsPropsEqual: ()=>markerComponentIsPropsEqual
});
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const markerComponentIsPropsEqual = (prev, next)=>{
    const messageKeysList = Object.keys(prev?.message || {});
    const sameMessage = messageKeysList.every((key)=>prev?.message[key] === next?.message[key]);
    const markerComponentPropsKeysList = Object.keys(prev?.message?.markerComponentProps || {});
    const sameMarkerComponentProps = markerComponentPropsKeysList.every((key)=>prev?.message?.markerComponentProps[key] === next?.message?.markerComponentProps[key]);
    return sameMessage && sameMarkerComponentProps;
};
const useMarkerComponentMemo = (markerComponents)=>{
    const [memoMarkerComponents, setMemoMarkerComponents] = (0, external_react_namespaceObject.useState)({});
    const componentCount = Object.keys(markerComponents || {}).length;
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (!markerComponents || 'object' != typeof markerComponents) return;
        const memoList = {};
        Object.keys(markerComponents).forEach((key)=>{
            const component = markerComponents[key];
            if ('function' == typeof component) memoList[key] = /*#__PURE__*/ external_react_default().memo(component, markerComponentIsPropsEqual);
        });
        setMemoMarkerComponents(memoList);
    }, [
        componentCount
    ]);
    return memoMarkerComponents;
};
exports.markerComponentIsPropsEqual = __webpack_exports__.markerComponentIsPropsEqual;
exports.useMarkerComponentMemo = __webpack_exports__.useMarkerComponentMemo;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "markerComponentIsPropsEqual",
    "useMarkerComponentMemo"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
